import { render, staticRenderFns } from "./IconArrowPath.vue?vue&type=template&id=80538f26"
import script from "./IconArrowPath.vue?vue&type=script&lang=js"
export * from "./IconArrowPath.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports